import { useEffect, useRef, useState } from 'react';

export const useCopyTooltip = (url: string) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (!showTooltip) return;

    const hide = () => setShowTooltip(false);
    window.addEventListener('scroll', hide, { once: true });

    return () => window.removeEventListener('scroll', hide);
  }, [showTooltip]);

  const handleClickCopy = async () => {
    await navigator.clipboard.writeText(url);
    setShowTooltip(true);

    setTimeout(() => {
      setShowTooltip(false);
    }, 2000);
  };

  return { showTooltip, handleClickCopy, buttonRef };
};
